export const getRankChartLegendLabel = ({ label, percentage }) => {
  return `${label} (${percentage}%)`;
};

export const getRankChartLegendTooltipId = (pk_EvaluationQuestionWeight) => {
  return `rank-chart-legend-${pk_EvaluationQuestionWeight}`;
};
